import { Fragment } from 'react'
import bg from 'assets/img/summer-programs/artificial-intelligence.jpg'

export const banner = {
  bannerBg: bg,
  heading: 'YEAR OF EMERGING TECH',
  programs:
    'Artificial Intelligence | Quantum Computing | Data Science | Cybersecurity',
  programsTypes: 'PDs, Webinars, Intensives & Research Opportunities',
  programsFor: 'Grades: 9 – 12, University + Educators',
  linksText: 'High School & College Mentored Research Applications Now Open!',
  bannerLinks: [
    // {
    //   linkText: (
    //     <Fragment>
    //       <span>
    //         <span>PD: Intro to AI Bootcamp</span>
    //         Learn More
    //       </span>
    //     </Fragment>
    //   ),
    //   link: '/train-1-week-pd',
    //   isExternal: false,
    // },
    // {
    //   linkText: (
    //     <Fragment>
    //       <span>
    //         <span>Free Webinars</span>
    //         2026 interest form
    //       </span>
    //     </Fragment>
    //   ),
    //   link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
    //   isExternal: true,
    // },
    // {
    //   linkText: (
    //     <Fragment>
    //       <span>
    //         <span>High School Research</span>
    //         Apply Now
    //       </span>
    //     </Fragment>
    //   ),
    //   link: '/nhsrp-application',
    //   isExternal: false,
    // },
    // {
    //   linkText: (
    //     <Fragment>
    //       <span>
    //         <span>Undergraduate Research</span>
    //         Apply Now
    //       </span>
    //     </Fragment>
    //   ),
    //   link: '/eqci-application',
    //   isExternal: false,
    // },
    
    {
      linkText: (
        <Fragment>
          <span>
            <span>High School Quantum Course</span>
            Enroll Now
          </span>
        </Fragment>
      ),
      link: 'https://www.frontier-tech.org/application-foundations-of-quantum-computing',
      isExternal: true,
    },
  ],
}
